import { ProfileScreen } from "@/app/modules/User";

export const Profile = () => {
  return <ProfileScreen />;
};
